class UnsupportedChainIdError extends Error {
  constructor(chainId?: number) {
    super(`Unsupported Chain Id : ${chainId}`);
  }
}

export default UnsupportedChainIdError;
